export enum LiveStateEnum {
  Scheduled = 0,
  Created = 1,
  InProgress = 2,
  Stopped = 3,
  Cancelled = 4,
}
